import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionCookieService } from '@app/core/cookies';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';

@Injectable({
  providedIn: 'root'
})
export class DirectShippingEligibilityGuard implements CanActivate {
  private matDialogConfig = {
    disableClose: false,
    maxWidth: 1280,
    data: {
      type: 'login',
      forced: true
    }
  };

  constructor(
    private sessionService: SessionCookieService,
    private router: Router,
    private plateformService: PlatformService,
    private dialog: MatDialog
  ) {}

  canActivate(): Observable<boolean> {
    // Since there is no auth nor cookies in server, we return true in SSR.
    if (this.plateformService.isServer) {
      return of(true);
    }

    const hasAuthenticationCookies = this.sessionService.hasSession() && this.sessionService.hasUserId();

    if (!hasAuthenticationCookies) {
      const dialogRef = this.dialog.open(AuthModalComponent, this.matDialogConfig);
      return dialogRef.afterClosed().pipe(
        map(res => {
          if (res === 'success') {
            return true;
          } else {
            this.router.navigate(['/']);
            return false;
          }
        })
      );
    }
    return of(true);
  }
}
